import { Component, OnInit, ChangeDetectionStrategy, signal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { JobService } from '@services/job.service';
import { HeaderComponent } from '@components/header/header.component';
import { CopyrightComponent } from '@components/copyright/copyright.component';
import { SocialSidebarComponent } from '@components/social-sidebar/social-sidebar.component';
import { DepartmentFilterComponent } from './department-filter/department-filter.component';
import { LocationFilterComponent } from './location-filter/location-filter.component';
import { JobOrderComponent } from './job-order/job-order.component';
import { JobComponent } from './job/job.component';
import { SearchPipe } from '@pipes/search.pipe';
import { NumberOfKeysPipe } from '@pipes/number-of-keys.pipe';
import { OrderBy } from '@pipes/orderBy.pipe';
import { JobSummary } from '@interfaces/jobs.interface';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        TranslateDirective,
        TranslatePipe,
        HeaderComponent,
        CopyrightComponent,
        SocialSidebarComponent,
        DepartmentFilterComponent,
        LocationFilterComponent,
        JobOrderComponent,
        JobComponent,
        SearchPipe,
        NumberOfKeysPipe,
        OrderBy
    ]
})
export class MainComponent implements OnInit {
  private readonly jobService = inject(JobService);

  public boardDto: any;
  public departmentFilter: any;
  public locationFilter: any;

  public textFilter: any;
  public orderByField = 'name';

  public jobs = signal<JobSummary[] | null>(null);
  public departments = signal<string[]>([]);
  public locations = signal<string[]>([]);

  async ngOnInit() {
    const jobs = await this.jobService.getJobs();    
    
    this.jobs.set(jobs);
    this.departments.set(this.jobService.departments);
    this.locations.set(this.jobService.locations.map(loc => loc.city));
  }

  departmentFilterChanged(event: any) {
    this.departmentFilter = event;
  }

  locationFilterChanged(event: any) {
    this.locationFilter = event;
  }

  orderChanged(order: any) {
    this.orderByField = order;
  }
}
